export default __webpack_public_path__ + "static/media/bookcover - front.18676d49.png";